import React from 'react';

export function ReplyIcon() {
  // https://lucide.dev/icons/reply
  return (
    <g stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 18v-2a4 4 0 0 0-4-4H4" />
      <path d="m9 17-5-5 5-5" />
    </g>
  );
}
